export const ERROR_ACTION_TYPE_POSTFIX = '_ERROR';

export enum ErrorEndpoint {
    ApiErrorUrl = '/apiError',
    ErrorUrl = '/error',
    WarningUrl = '/warning',
    InformationUrl = '/information'
}

export enum ApiErrorResponseCodes {
    InternalServerError = 500,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504
}

export enum ErrorResponseCodes {
    Unauthorized = 401,
    Forbidden = 403,
    MethodNotAllowed = 405
}

export enum WarningResponseCodes {
    BadRequest = 400,
    NotFound = 404,
    RequestTimeout = 408
}
